import EditInventoryManagement from './EditInventoryManagement';

export default EditInventoryManagement;



// WEBPACK FOOTER //
// ./src/components/Modals/EditInventoryManagement/index.jsx